import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	allProducts: {
		isSorted: false,
		objectArray: [],
	},
	featuredProducts: {
		isSorted: false,
		objectArray: [],
	},
	trendingProducts: {
		isSorted: false,
		objectArray: [],
	},
	seasonalProducts: {
		isSorted: false,
		objectArray: [],
	},
};

export const productsSlice = createSlice({
	name: 'products',
	initialState,
	reducers: {
		sortAll: (state, action) => {
			const sortedProducts = action.payload.allProductsSorted;
			state.allProducts.objectArray.push(...sortedProducts);
			state.allProducts.isSorted = true;
		},
		sortFeatured: (state, action) => {
			const sortedFeatured = action.payload.featured;
			state.featuredProducts.objectArray.push(...sortedFeatured);
			state.featuredProducts.isSorted = true;
		},
		sortTrending: (state, action) => {
			const sortedTrending = action.payload.trending;
			state.trendingProducts.objectArray.push(...sortedTrending);
			state.trendingProducts.isSorted = true;
		},
		sortSeasonal: (state, action) => {
			const sortedSeasonal = action.payload.seasonal;
			state.seasonalProducts.objectArray.push(...sortedSeasonal);
			state.seasonalProducts.isSorted = true;
		},
	},
});

export const { sortFeatured, sortTrending, sortSeasonal, sortAll } =
	productsSlice.actions;

export default productsSlice.reducer;
